import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: () => import('../views/Home/Home.vue') },
  { path: '/login', name: 'Login', component: () => import('../views/Login.vue') },
  //添加白名单
  { path: '/whiteList', name: 'whiteList', component: () => import('../views/whiteList/whiteList.vue') },
  { path: '/longTerm', name: 'longTerm', component: () => import('../views/longTerm/longTerm.vue') },
  // 添加仪表盘路由
  { path: '/dashboard', name: 'Dashboard', component: () => import('../views/Dashboard/Dashboard.vue') },
  // 添加告警信息路由
  { path: '/Warning', name: 'Warning', component: () => import('../views/Warning/Warning.vue') },
  // 添加新登录
  { path: '/Newlogin', name: 'Newlogin', component: () => import('../views/Newlogin/Newlogin.vue') }
]

const router = new VueRouter({
  routes
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  console.log("to=" + to.path)
  console.log("from=" + from.path)
  // to 要访问的路径
  // from 从哪个页面而来
  // next 是一个函数,表示放行
  // next() 放行, next('/Login')强制跳转
  // if(to.path === '/login') return next()
  // if(to.path === '/regist') return next()

  // 获取登录的状态
  // let token = window.sessionStorage.getItem("token")
  // if(!token) {
  // 	return next({path:'/login'})
  // }

  next()
})

export default router
